import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@mui/material'

import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { acGetAllBypassCustomers, acPostBypassCustomer } from '../../store/actions'
import { PrimaryButton, Alert } from '../default'

import { FormInputCnpj } from './formInputs'
import { FormValidationAddBypassCustomer } from './formValidations'

const defaultValues = {
    cnpj: ''
}

export const AddBypassCustomerForm = ({ onClose, setSnackbarData }) => {

    const dispatch = useDispatch()

    const isCreatingBypassCustomer = useSelector(state => state.bypassCustomers.isCreatingBypassCustomer)
    const hasErrorCreatedBypassCustomer = useSelector(state => state.bypassCustomers.hasErrorCreatedBypassCustomer)

    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationAddBypassCustomer)
    })

    const onSubmit = handleSubmit((data) => {

        const cleanCnpj = data.cnpj.replace(/\D/g, '')

        dispatch(acPostBypassCustomer({ cnpj: cleanCnpj }))
            .then(() => {
                onClose()
                setSnackbarData({ open: true, message: 'CNPJ cadastrado com sucesso!' })
                dispatch(acGetAllBypassCustomers())
                    .catch(error => console.error(error))
            })
            .catch(error => console.error(error))
    })

    const getErrorMessage = () => {
        if (!hasErrorCreatedBypassCustomer) return ''

        switch (hasErrorCreatedBypassCustomer.description) {
            case 'CNPJ_ALREADY_ADDED':
                return 'CNPJ já adicionado na lista de bypass!'
            default:
                return 'Erro ao adicionar CNPJ à lista de bypass!'
        }
    }

    return (
        <Box component='form' onSubmit={onSubmit} noValidate
            display='flex' flexDirection='column' gap={2}
        >

            <FormInputCnpj
                name='cnpj'
                label='CNPJ'
                control={control}
                errors={errors.cnpj}
                fullWidth
                required
            />

            {hasErrorCreatedBypassCustomer && (
                <Alert severity='error' message={getErrorMessage()} />
            )}

            <PrimaryButton
                label='Adicionar CNPJ'
                loading={isCreatingBypassCustomer}
                type='submit'
                fullWidth
            />
        </Box>
    )

}

AddBypassCustomerForm.propTypes = {
    onClose: PropTypes.func.isRequired,
    setSnackbarData: PropTypes.func.isRequired
}
